// mixins
import mobileCameraMixin from "@/mixins/mobile_wrapper/mobile-camera-mixin";

// utils
import { dynamicParameter } from "@/mixins/service/mixin-service";


const DEFAULT_CALLBACK = () => () => { };

export default function ({ storeFilesCallback = DEFAULT_CALLBACK, fileSubmitCallback = DEFAULT_CALLBACK, targetFieldPath, taskPayload }) {
    const getStoreFilesCallback = dynamicParameter(storeFilesCallback);
    const getFileSubmitCallback = dynamicParameter(fileSubmitCallback);
    const getTaskPayloadCallback = dynamicParameter(taskPayload);

    return {
        mixins: [
            mobileCameraMixin(self => self.submitFile, targetFieldPath, self => getTaskPayloadCallback(self)),
        ],
        methods: {
            handleCameraEvent() {
                return this.invokeCameraAction();
            },
            async storeFiles(files, currentFiles) {
                if (!files) return;
                let errors = [];

                for (let file of [...files]) {
                    if (this.fileNotPresentNow(file, currentFiles)) {
                        try {
                            await this.submitFile(file);
                        }
                        catch (e) {
                            errors.push(e);
                        }
                    }
                }

                if (errors.length > 0) {
                    throw (errors);
                }

                getStoreFilesCallback(this)();
            },
            async submitFile(file) {
                try {
                    getFileSubmitCallback(this)(file);
                } catch (e) {
                    throw (e);
                }
            },
            fileNotPresentNow(possibleNewFile, currentFiles) {
                const byName = currentFile => currentFile.data.pathName === possibleNewFile.pathName;

                return !currentFiles.find(byName);
            },
        },
    }
}
